module.exports = __webpack_public_path__ + "static/diags-399a5e8da2551d0f53829a730c181688.svg";